import React, { useState } from 'react';
import './LoginPage.css';
import ChangePinModal from './ChangePinModal';

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showChangePinModal, setShowChangePinModal] = useState(false);
  const [token, setToken] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      // Submit Login API and capture the response
      const response = await fetch('https://ux97q9k5kb.execute-api.us-east-2.amazonaws.com/prod/auth/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ userId: username, pin: password })
      });
      
      if (response.ok) {
        const data = await response.json();
        const authToken = data.token;
        localStorage.setItem('token', authToken);
        setToken(authToken);
        
        if (data.mustChangePIN) {
          setShowChangePinModal(true);
        } else {
          window.location.href = "/weekpicks";
        }
      } else {
        const error = await response.json();
        alert(error.error || 'Login failed');
      }
    } catch (error) {
      console.error('Login error:', error);
      alert('Login failed. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <h1>OIM FANTASY PARLAY</h1>
        <h2>Login</h2>
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              disabled={isLoading}
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={isLoading}
            />
          </div>
          <button type="submit" className="login-button" disabled={isLoading}>
            {isLoading ? (
              <>
                <span className="loading-spinner" style={{marginRight: "8px"}} />
                Logging in…
              </>
            ) : (
              "Login"
            )}
          </button>
        </form>
      </div>

      <ChangePinModal
        isOpen={showChangePinModal}
        onClose={() => setShowChangePinModal(false)}
        userId={username}
        token={token}
      />
    </div>
  );
};

export default LoginPage;
